import { useCallback } from 'react';
import useEventEmitter from "./useEventEmitter.js";
/**
 * A hook that simplifies creation of handlers for emitting
 * pointermove, pointerout, and pointerup events to EventEmitterContext.
 */
export default function usePointerEventEmitters(_ref) {
  let {
    source,
    onPointerOut = true,
    onPointerMove = true,
    onPointerUp = true,
    onPointerDown = true,
    onFocus = false,
    onBlur = false
  } = _ref;
  const emit = useEventEmitter();
  const emitPointerMove = useCallback(event => emit?.('pointermove', event, source), [emit, source]);
  const emitPointerOut = useCallback(event => emit?.('pointerout', event, source), [emit, source]);
  const emitPointerUp = useCallback(event => emit?.('pointerup', event, source), [emit, source]);
  const emitPointerDown = useCallback(event => emit?.('pointerdown', event, source), [emit, source]);
  const emitFocus = useCallback(event => emit?.('focus', event, source), [emit, source]);
  const emitBlur = useCallback(event => emit?.('blur', event, source), [emit, source]);
  return {
    onPointerMove: onPointerMove ? emitPointerMove : undefined,
    onFocus: onFocus ? emitFocus : undefined,
    onBlur: onBlur ? emitBlur : undefined,
    onPointerOut: onPointerOut ? emitPointerOut : undefined,
    onPointerUp: onPointerUp ? emitPointerUp : undefined,
    onPointerDown: onPointerDown ? emitPointerDown : undefined
  };
}